__turbopack_context__.v({
  "container": "MenuMobile-module__6q6aGW__container",
  "fadeInItems": "MenuMobile-module__6q6aGW__fadeInItems",
  "footer": "MenuMobile-module__6q6aGW__footer",
  "main": "MenuMobile-module__6q6aGW__main",
  "menu": "MenuMobile-module__6q6aGW__menu",
  "menuLink": "MenuMobile-module__6q6aGW__menuLink",
  "menuTitle": "MenuMobile-module__6q6aGW__menuTitle",
  "region": "MenuMobile-module__6q6aGW__region",
  "regionName": "MenuMobile-module__6q6aGW__regionName",
  "searchBtn": "MenuMobile-module__6q6aGW__searchBtn",
  "spacing--lg": "MenuMobile-module__6q6aGW__spacing--lg",
  "spacing--md": "MenuMobile-module__6q6aGW__spacing--md",
  "spacing--sm": "MenuMobile-module__6q6aGW__spacing--sm",
  "spacing--xl": "MenuMobile-module__6q6aGW__spacing--xl",
  "spacing--xs": "MenuMobile-module__6q6aGW__spacing--xs",
  "spacing--xxl": "MenuMobile-module__6q6aGW__spacing--xxl",
  "spacing--xxs": "MenuMobile-module__6q6aGW__spacing--xxs",
  "spacing--xxxl": "MenuMobile-module__6q6aGW__spacing--xxxl",
  "spacing--xxxs": "MenuMobile-module__6q6aGW__spacing--xxxs",
});
